import { cards } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">热门爆料 · 最新实锤</h2>
          <p className="text-sm text-foreground-500">精选全网最热门的黑料爆料，每条都经过瓜农多源验证</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <article
              key={card.id}
              className="group bg-background-50 rounded-xl overflow-hidden hover:bg-background-50/80 transition-colors cursor-pointer"
            >
              <div className="relative w-full h-[220px] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-2">
                  {card.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span><i className="ri-time-line mr-1"></i>{card.time}</span>
                  <span><i className="ri-eye-line mr-1"></i>{card.views}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}